import React from "react"
import { OrphanedDeliveredObjectsComponent } from "../../";

export default class MapCreativeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <>
                <OrphanedDeliveredObjectsComponent
                    {...this.props}
                    isCreative={true}
                />
            </>
        );
    };
};